import { onMounted, ref } from "vue";
import { defineStore } from "pinia";
import { getUnreadMsgCount, updateMsgReadStatus } from "~/api/user";

// 未读消息数
export const useMsgCountStore = defineStore(
	"msgCount",
	() => {
		const unReadMsgTotalCount = ref(); // 未读消息总数
		const unReadMsgSysCount = ref(); // 未读系统消息数
		const unReadMsgTeacherCount = ref(); // 未读老师消息数

		// 获取未读消息
		const getUnreadMsgCountFn = async () => {
			const res = await getUnreadMsgCount();
			const totalUnread = res.data.reduce(
				(total, item) => total + item.no_read_num,
				0
			);
			unReadMsgTotalCount.value = totalUnread;
			unReadMsgSysCount.value = res.data[1].no_read_num;
			unReadMsgTeacherCount.value = res.data[3].no_read_num;
		};

		onMounted(() => {
			if (import.meta.client && localStorage.getItem("token")) {
				getUnreadMsgCountFn();
			}
		});

		// 提交单条消息已读记录
		const sendReadMsg = async (params) => {
			const res = await updateMsgReadStatus(params);
			if (res.code === 200) {
				getUnreadMsgCountFn();
			}
		};

		// 重置store状态
		const resetMsgStore = () => {
			unReadMsgTotalCount.value = 0;
			unReadMsgSysCount.value = 0;
			unReadMsgTeacherCount.value = 0;
		};

		return {
			unReadMsgTotalCount,
			unReadMsgSysCount,
			unReadMsgTeacherCount,
			getUnreadMsgCountFn,
			sendReadMsg,
			resetMsgStore,
		};
	},
	{
		persist: {
			storage: import.meta.client ? localStorage : undefined,
		},
	}
);
